import script from "./TestInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TestInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./TestInfoModal.vue?vue&type=style&index=0&id=d1888640&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1888640"]])

export default __exports__